import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import BottomNav from "./BottomNav";
import { useProjectTOC } from "../context/ProjectTOCContext";
import styles from "../style/bottomDock.module.css";
import tocStyles from "../style/project/projectTOC.module.css";

const BottomDock = () => {
  const { pathname } = useLocation();
  const dockRef = useRef(null);
  const mobileTrackRef = useRef(null);
  const hasSkippedInitialTocScroll = useRef(false);
  const { items, activeSection } = useProjectTOC();
  const tocItems = items ?? [];
  const hasMobileToc = tocItems.length > 0;

  useEffect(() => {
    hasSkippedInitialTocScroll.current = false;
  }, [pathname]);

  useEffect(() => {
    const el = dockRef.current;
    if (!el) return;

    const syncHeight = () => {
      document.documentElement.style.setProperty(
        "--bottom-dock-height",
        `${el.getBoundingClientRect().height}px`
      );
    };

    syncHeight();

    const ro = new ResizeObserver(syncHeight);
    ro.observe(el);
    window.addEventListener("resize", syncHeight);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", syncHeight);
      document.documentElement.style.removeProperty("--bottom-dock-height");
    };
  }, [hasMobileToc]);

  useEffect(() => {
    if (!activeSection || !mobileTrackRef.current) return;

    if (!hasSkippedInitialTocScroll.current) {
      hasSkippedInitialTocScroll.current = true;
      return;
    }

    const activeLink = mobileTrackRef.current.querySelector(
      `[data-toc-id="${activeSection}"]`
    );
    if (!activeLink) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    activeLink.scrollIntoView({
      behavior: prefersReducedMotion ? "auto" : "smooth",
      inline: "center",
      block: "nearest",
    });
  }, [activeSection]);

  return (
    <div
      ref={dockRef}
      className={`${styles.bottomDock} text-light${
        hasMobileToc ? ` ${styles.bottomDockWithToc}` : ""
      }`}
    >
      {hasMobileToc && (
        <nav
          className="project-toc-mobile"
          aria-label="Project content quick links"
        >
          <div className={tocStyles.projectTocMobileTrack} ref={mobileTrackRef}>
            {tocItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={activeSection === item.id ? tocStyles.activeLink : ""}
                data-toc-id={item.id}
                aria-current={
                  activeSection === item.id ? "location" : undefined
                }
              >
                {item.title}
              </a>
            ))}
          </div>
        </nav>
      )}
      <BottomNav />
    </div>
  );
};

export default BottomDock;
